import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useScreenSize } from "app/lib/useScreenSize";
import DesktopPendingTransfers from "./DesktopPendingTransfers";
import MobileTransfers from "./MobileTransfers";
const PendingTransfers = ({ pendingTransfers, interAccountAllowed, setTransferView, }) => {
    const screenSize = useScreenSize();
    if (screenSize === "desktop") {
        return (_jsx(DesktopPendingTransfers, { pendingTransfers: pendingTransfers, interAccountAllowed: interAccountAllowed }));
    }
    else {
        return (_jsxs(_Fragment, { children: [_jsx("h2", { className: "sub-wrap", children: "Pending Transfers" }), _jsx(MobileTransfers, { transfers: pendingTransfers, setTransferView: setTransferView })] }));
    }
};
export default PendingTransfers;
